"use client";

import { cn } from "@/lib";
import { useState } from "react";
import { Accordion, FlexCol } from "../ui";
import { FaqItem } from "@/interfaces";
import HtmlRenderer from "../htmlRenderer";

const FaqServiceSection = ({
  FaqItems,
  className,
  hasTitle = true,
}: {
  FaqItems: FaqItem[];
  hasTitle?: boolean;
  className?: string;
}) => {
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);
  return (
    <FlexCol className={cn("mt-12 lg:mt-16 xl:mt-20", className)}>
      {hasTitle && (
        <h3 className="heading-2 text-primary-main mb-8">سوالات متدوال</h3>
      )}

      <FlexCol className={cn("mx-auto w-full max-w-[1100px] gap-2")}>
        {FaqItems.map((faq) => (
          <Accordion
            key={faq.id}
            title={faq.title}
            open={faq.id === openAccordionId}
            onOpenChange={(isOpen) => {
              setOpenAccordionId(isOpen ? faq.id : null);
            }}
          >
            {Array.isArray(faq.content) ? (
              <ul className="p-4 pt-2">
                {faq.content.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            ) : faq.contentHtml ? (
              <div className="p-4 pt-2">
                <HtmlRenderer htmlString={faq.contentHtml} />
              </div>
            ) : (
              <p className="p-4 pt-2">{faq.content}</p>
            )}
          </Accordion>
        ))}
      </FlexCol>
    </FlexCol>
  );
};

export default FaqServiceSection;
